import React from 'react';

import cn from 'classnames';

import { IUserHistoryRow } from '@entities/adminConversationUserHistory/model/types';
import { Flex, UiText } from '@shared/ui';

import cls from './UserHistoryRow.module.css';

interface UserHistoryRowProps {
    classes?: string;
    row: IUserHistoryRow;
    formType: string;
}

export const UserHistoryRow = ({ classes, row, formType }: UserHistoryRowProps) => (
    <div className={cn(cls.UserHistoryRow, classes)}>
        <Flex justify="center" align="center" className={cls.cell}>
            <UiText variant="mediumPlain" classes={cls.ellipsis}>
                {row.sentAt}
            </UiText>
        </Flex>
        <Flex justify="center" align="center" className={cls.cell}>
            <UiText variant="mediumPlain" classes={cls.ellipsis}>
                {row.recipientsCount}
            </UiText>
        </Flex>
        <Flex justify="center" align="center" className={cls.cell}>
            <UiText variant="mediumPlain" classes={cls.ellipsis}>
                {formType === 'broadcast' ? '-' : row.surveyCompleted.count}
            </UiText>
        </Flex>
        <Flex justify="center" align="center" className={cls.cell}>
            <UiText variant="mediumPlain" classes={cls.ellipsis}>
                {row.closed.count}
            </UiText>
        </Flex>
        <Flex justify="center" align="center" className={cls.cell}>
            <UiText variant="mediumPlain" classes={cls.ellipsis}>
                {row.assignmentType}
            </UiText>
        </Flex>
        <Flex justify="center" align="center" className={cls.cell}>
            <UiText variant="mediumPlain" classes={cls.ellipsis}>
                {row.assignmentSource}
            </UiText>
        </Flex>
    </div>
);
